.save {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

/* The outlined secondary button: a report is beside the page's main action,
 * never the main action itself. */
.button {
  min-height: 44px;
  padding: 0 14px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  color: var(--ink);
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}

.button:disabled {
  background: var(--sunk);
  color: var(--ink-3);
  cursor: default;
}

.error {
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}
